import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './DepartmentTestimonials.css';

const DepartmentTestimonials = ({ title, subtitle, testimonials }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const next = () => setActiveIndex((prev) => (prev + 1) % testimonials.length);
  const prev = () => setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const testimonialVariants = {
    enter: { opacity: 0, x: 50, scale: 0.95 },
    center: { opacity: 1, x: 0, scale: 1 },
    exit: { opacity: 0, x: -50, scale: 0.95 }
  };

  return (
    <section className="department-testimonials">
      <div className="container">
        <div className="department-testimonials-header">
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
        </div>

        <div className="testimonials-carousel">
          <button className="carousel-btn prev" onClick={prev}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <div className="testimonials-track">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeIndex}
                className="testimonial-card"
                variants={testimonialVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.5 }}
              >
                <div className="testimonial-quote">
                  <FontAwesomeIcon icon={faQuoteRight} />
                </div>
                <p className="testimonial-text">{testimonials[activeIndex].text}</p>
                <div className="testimonial-author">
                  <img src={testimonials[activeIndex].image} alt={testimonials[activeIndex].name} />
                  <div>
                    <h4>{testimonials[activeIndex].name}</h4>
                    <span>{testimonials[activeIndex].role}</span>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button className="carousel-btn next" onClick={next}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        <div className="testimonials-dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DepartmentTestimonials;